import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  AppBar,
  Box,
  CircularProgress,
  Dialog,
  Grid,
  Tabs,
  Tab,
  IconButton,
  Toolbar,
  Typography,
} from '@mui/material';
import domtoimage from 'dom-to-image';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';
import Slide from '@mui/material/Slide';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useDispatch, useSelector } from 'react-redux';
import { testSelector } from '../../store/user/user.selector';
import { setResultTest } from '../../store/user/user.reducer';
import { makeStyles } from '@mui/styles';
import { jsPDF } from 'jspdf';
import PVQ from './PVQ';
import Clifton from './Clifton';
import JobGroups from './JobGroups';
import { FindMaxValueJobGroup } from '../../utils/common';
import './Shabnam-normal';
import { getResultTestByTestId } from '../../apis/user';
import Loading from '../Loading';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const useStyles = makeStyles(() => ({
  root: {
    width: '100% !important',
  },
}));

const ResultTest = () => {
  const dispatch = useDispatch();
  const styles = useStyles();
  const ref = useRef(null);
  const [exporting, setExporting] = useState(false);
  const cliftonRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [maxKeyJobGroup, setMaxKeyJobGroup] = useState('');
  const [sortJobGroupArray, setSortJobGroupArray] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [userDate, setUserDate] = useState('');

  const test = useSelector(testSelector);
  const { openResultDialog, resultTest, fullName, tabs = [] } = test || {};

  const { pvq, job_group, skils, cilifton } = resultTest || {};

  const initialTestState = () => {
    const jobGroupArray = Object.entries(job_group)
      .map((item) => {
        return {
          key: item[0],
          value: Math.floor(item[1] * 1000000),
        };
      })
      .sort((a, b) => b.value - a.value);

    if (Array.isArray(jobGroupArray) && jobGroupArray.length !== 0) {
      setMaxKeyJobGroup(FindMaxValueJobGroup(jobGroupArray));
      setSortJobGroupArray(jobGroupArray);
    }

    const { testDate = '' } = tabs?.[tabValue] || {};
    setUserDate(testDate.slice(0, 4) + '/' + testDate.slice(5, 7) + '/' + testDate.slice(8, 10));
  };

  useEffect(() => {
    if (resultTest) initialTestState();
  }, [resultTest]);

  const handleClose = () => dispatch(setResultTest({ openResultDialog: false }));

  const onGeneratesPDF = useCallback(async () => {
    if (ref.current === null) return;

    try {
      setExporting(true);
      const dataUrl = await domtoimage?.toPng(ref.current, { cacheBust: true });

      console.log('=>', cliftonRef);

      if (cliftonRef && cliftonRef.current) {
        const cliftonUrl = await domtoimage?.toPng(cliftonRef.current, { cacheBust: true });
        const link = document.createElement('a');
        link.download = 'test.png';
        link.href = dataUrl;

        const pdf = new jsPDF();
        pdf.setFont('Shabnam');
        const imgProps = pdf.getImageProperties(dataUrl);
        const imgCliftonProps = pdf.getImageProperties(cliftonUrl);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        const pdfCliftonHeight = (imgCliftonProps.height * pdfWidth) / imgCliftonProps.width;

        const { height } = pdf.internal.pageSize;

        pdf.text(` کارنامه ${fullName} - ${userDate} `, pdfWidth / 2, 5, 'center');
        pdf.setFontSize(8);
        pdf.setR2L(true);
        pdf?.addImage(dataUrl, 'PNG', 0, 10, pdfWidth * 0.95, pdfHeight);
        pdf?.addImage(
          cliftonUrl,
          'PNG',
          0,
          Math.ceil(height / 2) + 15,
          pdfWidth * 0.98,
          pdfCliftonHeight,
        );

        pdf.save(`${fullName}.pdf`);
        setExporting(false);
      } else
        setTimeout(() => {
          setExporting(false);
        }, 1_000);
    } catch (e) {
      setExporting(false);
    }
  }, [ref, cliftonRef, exporting, test, userDate]);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    setLoading(true);
    const { testId, testDate = '' } = tabs[newValue] || {};
    setUserDate(testDate.slice(0, 4) + '/' + testDate.slice(5, 7) + '/' + testDate.slice(8, 10));

    getResultTestByTestId(testId)
      .then((res) => dispatch(setResultTest({ resultTest: res })))
      .catch((e) => console.log({ e }))
      .finally(() => setLoading(false));
  };

  return (
    <Dialog
      fullScreen
      open={openResultDialog}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar className='spaceBetween'>
          <Box display='flex'>
            <IconButton edge='start' color='inherit' onClick={handleClose} aria-label='close'>
              <CloseRoundedIcon />
            </IconButton>
            <IconButton onClick={onGeneratesPDF} disabled={exporting}>
              {exporting ? (
                <CircularProgress size={18} color='info' />
              ) : (
                <ArrowDownwardRoundedIcon />
              )}
            </IconButton>
          </Box>

          <Typography sx={{ ml: 2 }} variant='h6' component='div' color='white'>
            {` ${fullName} گزارش نتیجه تست کاربر`}
          </Typography>
        </Toolbar>
      </AppBar>

      <Box className='flexCenter' sx={{ width: '100%', direction: 'rtl' }}>
        <Tabs
          color='primary'
          classes={{ root: styles.root }}
          value={tabValue}
          onChange={handleChange}
          variant='scrollable'
          scrollButtons='auto'
          aria-label='scrollable auto tabs example'
        >
          {tabs?.map((item) => (
            <Tab
              wrapped
              key={item.testId.toString()}
              label={
                <div>
                  <Typography component='p' color='text.main'>
                    {item.testDate?.slice(0, 4) +
                      '/' +
                      item.testDate?.slice(5, 7) +
                      '/' +
                      item.testDate?.slice(8, 10)}
                  </Typography>
                  <Typography component='span' color='text.dark'>
                    {`(${item.testDate?.slice(11, 13)}:${item.testDate?.slice(14, 16)})`}
                  </Typography>
                </div>
              }
            />
          ))}
        </Tabs>
      </Box>

      {loading ? (
        <Loading />
      ) : (
        <Box width='100%' dir='rtl' p={2} ref={ref} bgcolor='white'>
          {maxKeyJobGroup && skils && (
            <JobGroups
              sortJobGroupArray={sortJobGroupArray}
              maxKeyJobGroup={maxKeyJobGroup}
              setMaxKeyJobGroup={setMaxKeyJobGroup}
              skils={skils[maxKeyJobGroup]}
            />
          )}

          <Grid container mt={1}>
            <Grid item xl={6} lg={6} xs={12} pt={1} pl={1.5}>
              {cilifton && (
                <Clifton cilifton={cilifton} exporting={exporting} cliftonRef={cliftonRef} />
              )}
            </Grid>
            <Grid item xl={6} lg={6} xs={12} pt={1} pr={1.5}>
              {pvq && <PVQ pvq={pvq} />}
            </Grid>
          </Grid>
        </Box>
      )}
    </Dialog>
  );
};

export default ResultTest;
